var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.show
    ? _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 d-flex" }, [
          _c(
            "div",
            { staticClass: "me-3" },
            [_c("Avatar", { attrs: { user: _vm.student } })],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "w-100" }, [
            _c("div", { staticClass: "mb-2" }, [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.body,
                    expression: "body",
                  },
                ],
                ref: "autosize",
                staticClass: "form-control reply--input",
                attrs: { placeholder: _vm.$t("Reply"), rows: "1" },
                domProps: { value: _vm.body },
                on: {
                  input: [
                    function ($event) {
                      if ($event.target.composing) return
                      _vm.body = $event.target.value
                    },
                    _vm.autosize,
                  ],
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex justify-content-between mb-3" }, [
              _c("div", [
                !_vm.image && _vm.isAdmin
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-link text-secondary btn-sm me-1",
                        on: { click: _vm.initiateAddImage },
                      },
                      [_c("i", { staticClass: "far fa-image" })]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", [
                  _vm.image
                    ? _c("img", {
                        staticClass: "img-fluid",
                        staticStyle: { "max-width": "200px" },
                        attrs: { src: _vm.imgUrl, alt: "" },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("input", {
                    ref: "file",
                    staticClass: "d-none",
                    attrs: {
                      type: "file",
                      accept: "image/png, image/gif, image/jpeg",
                    },
                    on: { change: _vm.fileChanged },
                  }),
                ]),
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-secondary btn-sm",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.toggleReplyCreate.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm._f("translate")("Cancel")) +
                        "\n          "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary btn-sm",
                    class: { disabled: _vm.notValid },
                    attrs: { disabled: _vm.notValid },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.addReply.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm._f("translate")("Reply")) +
                        "\n          "
                    ),
                  ]
                ),
              ]),
            ]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }